import { Dtos, formatToDollar, formatToPercent } from "@inrev/common";
import type { DynamicDataTableColumn } from "@portal/components/ui/DynamicDataTable/types";

export type SfaaClassExperienceRow = Dtos.Admin.SfaaClassExperience.Row.Response;

export const sfaaClassExperienceColumns: readonly DynamicDataTableColumn<SfaaClassExperienceRow>[] =
	[
		{
			id: "line",
			accessorKey: "line",
			header: "Line",
			size: 180,
			minSize: 140,
			enableResizing: true,
			enableSorting: true,
			headerFilter: { type: "checkbox" },
		},
		{
			id: "subline",
			accessorKey: "subline",
			header: "Subline",
			size: 180,
			minSize: 140,
			enableResizing: true,
			enableSorting: true,
			headerFilter: { type: "checkbox" },
		},
		{
			id: "location",
			accessorKey: "location",
			header: "Location",
			size: 150,
			minSize: 120,
			enableResizing: true,
			enableSorting: true,
			headerFilter: { type: "checkbox" },
		},
		{
			id: "sfaaCode",
			accessorKey: "sfaaCode",
			header: "SFAA Code",
			size: 120,
			minSize: 100,
			enableResizing: true,
			enableSorting: true,
			headerFilter: { type: "checkbox" },
		},
		{
			id: "year",
			accessorFn: ({ year }) => year.toString(),
			header: "Year",
			size: 90,
			minSize: 80,
			enableSorting: true,
			headerFilter: { type: "checkbox" },
			cell: ({ row }) => row.original.year,
		},
		{
			id: "writtenPremium",
			accessorKey: "writtenPremium",
			header: "Written Premium",
			size: 170,
			minSize: 140,
			enableResizing: true,
			enableSorting: true,
			cell: ({ row }) => formatToDollar(row.original.writtenPremium, true),
		},
		{
			id: "earnedPremium",
			accessorKey: "earnedPremium",
			header: "Earned Premium",
			size: 170,
			minSize: 140,
			enableResizing: true,
			enableSorting: true,
			cell: ({ row }) => formatToDollar(row.original.earnedPremium, true),
		},
		{
			id: "incurredLoss",
			accessorKey: "incurredLoss",
			header: "Incurred Loss",
			size: 160,
			minSize: 130,
			enableResizing: true,
			enableSorting: true,
			cell: ({ row }) => formatToDollar(row.original.incurredLoss, true),
		},
		{
			id: "lossRatio",
			accessorFn: ({ lossRatio }) => lossRatio ?? -1,
			header: "Loss Ratio",
			size: 120,
			minSize: 100,
			enableSorting: true,
			cell: ({ row }) =>
				row.original.lossRatio === null ? "—" : formatToPercent(row.original.lossRatio),
		},
	];
